import { render, staticRenderFns } from "./RepostedTo.vue?vue&type=template&id=6a573cef"
import script from "./RepostedTo.vue?vue&type=script&lang=js"
export * from "./RepostedTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports